import { RootState } from '..';

export const selectFileUrl = (state: RootState) =>
    state.modalWindowReducer.fileUrl;

export const selectFileBlob = (state: RootState) =>
    state.modalWindowReducer.fileBlob;

export const selectIsModalWindowOpen = (state: RootState) =>
    state.modalWindowReducer.isOpen;

export const selectFileId = (state: RootState) =>
    state.modalWindowReducer.fileId;

export const selectFileMimeType = (state: RootState) =>
    state.modalWindowReducer.fileMimetype;
